module.exports = __webpack_public_path__ + "static/media/lesson_chapter_1.dd113510.png";